import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { u as t } from "./index-6a632112.mjs";
import { k as x, s as n, l as $, e as b, c as a } from "./themes-5f0b3c3d.mjs";
import { t as l } from "./textStyles-42cab346.mjs";
import "react";
import { S as y } from "./checkmarkFilled-c2b01ef1.mjs";
import { S as w } from "./warningFilled-691cfde1.mjs";
import { useAccessibilityProps as B } from "./accessibility.js";
import { u as V } from "./uniqueId-321287e8.mjs";
import { L as P } from "./label-3b996c7d.mjs";
import "./lineHeights-72d3110c.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./informationFilled-05d57719.mjs";
const S = t.div`
  display: flex;
  flex-direction: column;
  font-family: ${x};
  width: 100%;
  gap: ${n["2x"]};
`, T = t.span`
  display: flex;
  align-items: center;
  color: ${(r) => r.$status === "error" ? r.theme.components.progressBar.errorTextColor : r.theme.components.progressBar.helperTextColor};
  font-size: ${l.body.medium.s.fontSize};
  letter-spacing: ${$[0]};
  line-height: ${l.body.medium.s.lineHeight};
  font-weight: ${b.regular.S.fontWeight};
  height: ${n["5x"]};
`, v = t.div`
  background-color: ${a.brandTwilight[300]};
  border-radius: 10px;
  width: 100%;
  height: 8px;
`, C = t.div`
  --progress-bar-background-color: ${(r) => {
  switch (r.$status) {
    case "success":
      return r.theme.components.progressBar.successProgressBarColor;
    case "error":
      return r.theme.components.progressBar.errorTextColor;
    default:
      return r.theme.components.progressBar.defaultProgressBarColor;
  }
}};

  --progress-bar-width: ${(r) => {
  if (r?.$progressValue && r?.$progressValue > (r?.maxValue || 100))
    return "100%";
  switch (r.$status) {
    case "success":
    case "error":
      return "100%";
    default:
      return `${r?.$progressValue && r.$maxValue ? r?.$progressValue * 100 / r.$maxValue : r.$progressValue}%`;
  }
}};

  background-color: var(--progress-bar-background-color);
  height: 8px;
  border-radius: 10px;
  width: var(--progress-bar-width);
`;
function Z({
  helperText: r,
  progressValue: i = 0,
  maxValue: s = 100,
  status: o = "default",
  labelProp: c,
  infoProp: m,
  trailingText: p,
  accessibilityOptions: u = {},
  style: g
}) {
  const d = `${V()}`, h = B("progressbar", {
    ariaValuMax: s,
    ariaValuenow: i,
    ariaLabelledBy: d,
    ...u
  });
  return /* @__PURE__ */ f(S, { style: g, children: [
    /* @__PURE__ */ e(
      P,
      {
        labelProp: {
          ...c
        },
        infoProp: {
          infoText: "",
          infoType: "tooltip",
          popupTipHeader: "Info",
          ...m
        },
        trailingText: o === "default" ? p : "",
        trailingElement: o === "success" ? /* @__PURE__ */ e(
          y,
          {
            "aria-label": "success",
            height: "16px",
            width: "16px",
            color: a.utilitySuccess[1e3]
          }
        ) : o === "error" ? /* @__PURE__ */ e(
          w,
          {
            "aria-label": "warning",
            height: "16px",
            width: "16px",
            color: a.utilityDanger[1e3]
          }
        ) : void 0
      }
    ),
    /* @__PURE__ */ e(v, { children: /* @__PURE__ */ e(
      C,
      {
        $status: o,
        $progressValue: i,
        $maxValue: s,
        ...h,
        tabIndex: 0
      }
    ) }),
    r && /* @__PURE__ */ e(T, { $status: o, children: r })
  ] });
}
export {
  Z as ProgressBar
};
